export default {"src":"/_next/static/media/search.f3ea3a8b.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};